"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loader = void 0;
var bar_1 = __importDefault(require("./bar"));
var infinite_1 = __importDefault(require("./infinite"));
/**
 * Determines the available loaders.
 */
var loaders = {
    bar: bar_1.default,
    infinite: infinite_1.default
};
/**
 * Creates the loader given the options.
 */
var loader = function (options) { return "\n    <div class=\"chartisan-help-block\">\n        ".concat(loaders[options.type](options), "\n        ").concat(options.text != ''
    ? "\n                <div class=\"chartisan-help-text\" style=\"color: ".concat(options.textColor, ";\">\n                    ").concat(options.text, "\n                </div>")
    : '', "\n    </div>\n"); };
exports.loader = loader;
